module.exports = __webpack_public_path__ + "img/gongzhonghao.69f5cd3f.jpg";